// extracted by mini-css-extract-plugin
export var paginationContainer = "_82-0";